import api from '../utils/api';
import type {
  TipologiaScadenza,
  CreateTipologiaDto,
  UpdateTipologiaDto,
  TipologiaFilters
} from '../types/tipologia.types';
import type { PaginatedResponse, QueryParams } from '../types/common.types';

export const tipologieService = {
  // Get all tipologie with pagination and filters
  getAll: async (params: QueryParams & TipologiaFilters): Promise<PaginatedResponse<TipologiaScadenza>> => {
    const response = await api.get('/tipologie-scadenze', { params });
    return response.data;
  },

  // Get all active tipologie (for selects/dropdowns)
  getAllActive: async (): Promise<TipologiaScadenza[]> => {
    const response = await api.get('/tipologie-scadenze/active');
    return response.data;
  },

  // Get tipologia by ID
  getById: async (id: string): Promise<TipologiaScadenza> => {
    const response = await api.get(`/tipologie-scadenze/${id}`);
    return response.data;
  },

  // Create new tipologia
  create: async (data: CreateTipologiaDto): Promise<TipologiaScadenza> => {
    const response = await api.post('/tipologie-scadenze', data);
    return response.data;
  },

  // Update tipologia
  update: async (id: string, data: UpdateTipologiaDto): Promise<TipologiaScadenza> => {
    const response = await api.put(`/tipologie-scadenze/${id}`, data);
    return response.data;
  },

  // Delete tipologia
  delete: async (id: string): Promise<void> => {
    await api.delete(`/tipologie-scadenze/${id}`);
  },

  // Toggle tipologia active status
  toggleActive: async (id: string): Promise<TipologiaScadenza> => {
    const response = await api.patch(`/tipologie-scadenze/${id}/toggle-active`);
    return response.data;
  }
};

export default tipologieService;
